import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface INotificationState {
    notificationCount: number,
    isOpen: boolean,
    isSheetOpen: boolean
}

const initialState: INotificationState = {
    notificationCount: 0,
    isOpen: false,
    isSheetOpen: false,
}

export const notificationSlice = createSlice({
    name: 'notificationSlice',
    initialState,
    reducers: {
        setNotificationCount: (state, action: PayloadAction<number>) => { state.notificationCount = action.payload },
        incrementNotificationCount: (state) => { state.notificationCount++ },
        setNotificationModalHidden: (state) => {
            state.isOpen = false
        },
        setNotificationModalOpen: (state) => {
            state.isOpen = true
        },
        setNotificationSheetOpen: (state, action: PayloadAction<boolean>) => {
            state.isSheetOpen = action.payload
        },
    },
})

export const {
    incrementNotificationCount,
    setNotificationCount,
    setNotificationModalHidden,
    setNotificationModalOpen,
    setNotificationSheetOpen,
} = notificationSlice.actions

export default notificationSlice.reducer
